import { render, staticRenderFns } from "./DocumentosGenerales.vue?vue&type=template&id=a781212a&scoped=true&"
import script from "./DocumentosGenerales.vue?vue&type=script&lang=js&"
export * from "./DocumentosGenerales.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosGenerales.vue?vue&type=style&index=0&id=a781212a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a781212a",
  null
  
)

export default component.exports